.overlay { position: fixed; inset: 0; z-index: 400; background: var(--scrim); border: none; }

.modal {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 401;
  width: 620px;
  max-width: 95vw;
  max-height: 88vh;
  display: flex;
  flex-direction: column;
  background: var(--card-bg);
  border-radius: var(--r-lg);
  box-shadow: 0 20px 60px rgba(15, 23, 42, .2);
  overflow: hidden;
}

.header {
  display: flex;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid var(--border);
  flex-shrink: 0;
}

.title { font-size: 15px; font-weight: 700; }
.subtitle { font-size: 13px; color: var(--text2); margin-top: 2px; }
.spacer { flex: 1; }

.close { background: none; border: none; font-size: 22px; line-height: 1; color: var(--text2); cursor: pointer; }
.close:hover { color: var(--text); }

.body { flex: 1; overflow: hidden; padding: 14px 20px; display: flex; }

/* Моноширинный шрифт: в тексте есть выровненные пробелами колонки
   и линии-разделители, пропорциональный шрифт их сломал бы. */
.text {
  flex: 1;
  width: 100%;
  min-height: 300px;
  padding: 12px;
  font-family: var(--mono);
  font-size: 13px;
  line-height: 1.5;
  border: 1px solid var(--border);
  border-radius: var(--r-sm);
  background: var(--input-bg);
  color: var(--text);
  resize: none;
}

.footer {
  display: flex;
  gap: 8px;
  padding: 12px 20px;
  border-top: 1px solid var(--border);
  flex-shrink: 0;
}

.button {
  padding: 8px 15px;
  font-size: 12.5px;
  border: 1px solid var(--border);
  border-radius: var(--r-sm);
  background: var(--card-bg);
  color: var(--text2);
  cursor: pointer;
}

.button:hover { border-color: var(--blue); color: var(--blue); }

.primary { background: var(--blue); border-color: var(--blue); color: #fff; font-weight: 600; }
.primary:hover { background: var(--blue-dark); color: #fff; }

.copied { background: var(--action-save); border-color: var(--action-save); color: #fff; font-weight: 600; }

@media (max-width: 640px) {
  .modal { width: 100%; max-width: 100%; height: 100%; max-height: 100%; border-radius: 0; top: 0; left: 0; transform: none; }
  .text { font-size: 12.5px; }
}
